import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ClipboardState } from "@thkStore/Store/Widgets/Clipboard/ClipboardState";
import { clearClipboardStorage, loadClipboardFromStorage, setClipboardToStorage } from "@thkStore/Store/Widgets/Clipboard/ClipboardStorage";
import { Draft } from "immer";

const initialState: ClipboardState = {
    items: {},
    parentProductId: "",
};

const reducer = {
    "Widgets/Clipboard/SetItem": (
        draft: Draft<ClipboardState>,
        action: {
            parameter: {
                productId: string;
                productName: string;
                qtyOrdered: number;
                addIncludes: boolean;
                viewOnly: boolean;
                partNo?: string;
                unitPrice?: number;
                weight?: number;
                length?: number;
                g1?: number;
                g2?: number;
                daysToShip?: string;
            }
        },
    ) => {
        if (action.parameter.qtyOrdered <= 0)
        {
            delete draft.items[action.parameter.productId];
        }
        else{
            draft.items[action.parameter.productId] = {
                ...action.parameter,
                includes: draft.items[action.parameter.productId]?.addIncludes === action.parameter.addIncludes ? { ...draft.items[action.parameter.productId]?.includes ?? {} } : {},
                customIncludes: draft.items[action.parameter.productId]?.addIncludes === action.parameter.addIncludes ? { ...draft.items[action.parameter.productId]?.customIncludes ?? {} } : {},
                viewOnly: action.parameter.viewOnly
            };

        }
        setClipboardToStorage(draft);
    },
    "Widgets/Clipboard/RemoveItem": (
        draft: Draft<ClipboardState>,
        action: { parameter: { productId: string } },
    ) => {
        delete draft.items[action.parameter.productId];
        setClipboardToStorage(draft);
    },
    "Widgets/Clipboard/ClearAll": (
        draft: Draft<ClipboardState>
    ) => {
        draft.items = {};
        clearClipboardStorage();
    },
    "Widgets/Clipboard/RestoreFromStorage": (
        draft: Draft<ClipboardState>,
        actions: { parameter: {
            parentProductId: string;
        } 
    }
    ) => {
        const storedState = loadClipboardFromStorage();
        if (storedState && storedState.parentProductId === actions.parameter.parentProductId) {
            draft.parentProductId = storedState.parentProductId;
            draft.items = storedState.items;            
            return;
        }
        clearClipboardStorage();
        draft.parentProductId = actions.parameter.parentProductId;
        draft.items = {};
        setClipboardToStorage(draft);        
    },
    "Widgets/Clipboard/SetParentProductId": (
        draft: Draft<ClipboardState>,
        action: { parentProductId: string }
    ) => {
        draft.parentProductId = action.parentProductId;
        setClipboardToStorage(draft);
    },
    "Widgets/Clipboard/SetIncludeItem": (
        draft: Draft<ClipboardState>,
        action: {
            parameter: {
                parentProductId: string;
                includeProductId: string;
                productName: string;
                qtyOrdered: number;
            }
        },
    ) => {
        const parent = draft.items[action.parameter.parentProductId];
        if (parent) {
            parent.includes[action.parameter.includeProductId] = {
                productId: action.parameter.includeProductId,
                productName: action.parameter.productName,
                qtyOrdered: action.parameter.qtyOrdered,
            };
            setClipboardToStorage(draft);
        }
    },
    "Widgets/Clipboard/SetCustomIncludeItem": (
        draft: Draft<ClipboardState>,
        action: {
            parameter: {
                localId: string;
                parentProductId: string;
                includeProductId: string;
                productName: string;
                qtyOrdered: number;                
                unitPrice: number;
                weight: number;
                length: number;
                g1: number;
                g2: number;
                daysToShip: string;
            }
        },
    ) => {
        const parent = draft.items[action.parameter.parentProductId];
        if (parent) {
            parent.customIncludes[action.parameter.localId] = {
                localId: action.parameter.localId,
                productId: action.parameter.includeProductId,
                productName: action.parameter.productName,
                qtyOrdered: action.parameter.qtyOrdered,                
                unitPrice: action.parameter.unitPrice,
                weight: action.parameter.weight,
                length: action.parameter.length,
                g1: action.parameter.g1,
                g2: action.parameter.g2,
                daysToShip: action.parameter.daysToShip,
            };
            setClipboardToStorage(draft);
        }
    },
    "Widgets/Clipboard/RemoveIncludeItem": (
        draft: Draft<ClipboardState>,
        action: {
            parameter: {
                parentProductId: string;
                includeProductId: string;
            }
        },
    ) => {
        const parent = draft.items[action.parameter.parentProductId];
        if (parent) {
            delete parent.includes[action.parameter.includeProductId];
            setClipboardToStorage(draft);
        }
    },
    "Widgets/Clipboard/RemoveCustomIncludeItem": (
        draft: Draft<ClipboardState>,
        action: {
            parameter: {
                parentProductId: string;
                localId: string;
            }
        },
    ) => {
        const parent = draft.items[action.parameter.parentProductId];
        if (parent) {
            delete parent.customIncludes[action.parameter.localId];
            setClipboardToStorage(draft);
        }
    }
};

const clipboardReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).clipboard = clipboardReducer;

  export type ApplicationClipboardState = {
      clipboard: ClipboardState;
  } & ApplicationState;

  type Reducers = {
      clipboard: typeof clipboardReducer;
  };

  export type ClipboardActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;